import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { api } from "src/shared/setup/API/api";

export const UseReportProductionContract = () => {
  const { userPerfil } = useAuthContext();
  const { handleGetAlert } = useLayoutMainContext();
  const { setLoadingGravar } = useConfigPageContext();
  const { valueAutoCompFiliais, valueAutoCompProdutorActive } =
    UseAutoCompletedAll();

  const {
    setListReportProductionOperator,
    valuesInputsProductionOperator,
    valueAutoCompAdministradoras,
    valueAutoCompModalidades,
    valueAutoCompOperadoras,
  } = useContextReportsProduction();

  const objData = {
    start_date: valuesInputsProductionOperator.start_date,
    end_date: valuesInputsProductionOperator.end_date,
    type_date: valuesInputsProductionOperator.type_date,

    id_filial: valueAutoCompFiliais.map((item) => item.id),

    operadoras: valueAutoCompOperadoras.map((item) => item.id),
    modalidades: valueAutoCompModalidades.map((item) => item.id),
    administradoras: valueAutoCompAdministradoras
      .map((item) => item.id)
      .filter((id) => id !== ""),

    type_report:
      userPerfil?.type_user === "PRODUCER"
        ? "UNIQUE"
        : valuesInputsProductionOperator.type_report,

    code_produtor:
      userPerfil?.type_user === "PRODUCER"
        ? String(userPerfil.id)
        : String(valueAutoCompProdutorActive.id),
  };

  const handleGetReportProductionContract = async () => {
    if (!valuesInputsProductionOperator.start_date)
      return handleGetAlert({ message: `Escolha uma data inicial !` });

    if (!valuesInputsProductionOperator.end_date)
      return handleGetAlert({ message: `Escolha uma data final !` });

    setLoadingGravar(true);
    setListReportProductionOperator(undefined);

    const AllDatas = { ...objData };

    return api
      .post("/report/productionOperator", AllDatas)
      .then((res) => {
        setListReportProductionOperator(res.data);
      })
      .catch((error) => {
        handleGetAlert({ message: error.response.data.message });
      })
      .finally(() => setLoadingGravar(false));
  };

  const handleSubmit = () => handleGetReportProductionContract();

  return { handleSubmit };
};
